import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UserMasterModel } from './usermaster-model';
import * as ngswal from "sweetalert";
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';

import { ApiMethod } from '../../apimethods/api-method';

declare var $;

@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  styleUrls: ['./user-master.component.css'],
  providers: [DatePipe]
})
/** user-master component*/
export class UserMasterComponent implements OnInit {

  modelItem = new UserMasterModel();

  showModal: boolean;
  content: string;
  title: string;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;
  popUpButtonText: string;

  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  myDate = new Date();
  maxDate: string;
  userMasterList: any;
  public UsertypeList: any;
  public roleMasterList: any;
  Dropdownapi: any;
  public userMasterTabHide: boolean = GlobalConstants.CheckMetadataView('UserMasterTabHide');
  ngOnInit() {
    ApiMethod.getBaseUrl();
  }

  ngAfterViewChecked(): void {
    let jrlIdList = this.modelItem.JrlIDListPop;
    if (jrlIdList != null && $('#lstJournals').find('option').length > 0) {
      $('#lstJournals').val(jrlIdList).change();
      this.modelItem.JrlIDListPop = null;
    }
  }

  constructor(private router: Router, private datePipe: DatePipe) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <UserMasterModel>data["UserMasterPage"];
        localStorage.aEID = 0;
        this.maxDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
        this.GetPublisherList();
        this.GetroleList();
        this.GetUserTypeList();
        this.GetUserMasterList();
        this.resetForm();
        this.DepartmentDropdownapi();
        this.GetActivityList();
        /*$('.select2').select2({ dropdownParent: "#myModal" });*/

        //Department DropDown
        $("#ddlDepartmentList").select2({
          placeholder: "Select Department",
          allowClear: true, tags: true,
          dropdownParent: "#myModal"
        });

        $("#lstPublihsers").select2({
          placeholder: "Select Publisher",
          dropdownParent: "#myModal"
        });
        $("#lstJournals").select2({
          placeholder: "Select Journal",
          dropdownParent: "#myModal"
        });
        $("#lstAllocatePublihsers").select2({
          placeholder: "Select Publisher",
          dropdownParent: "#myModal"
        });
        $("#lstAllocatedActivity").select2({
          placeholder: "Select Activity",
          dropdownParent: "#myModal"
        });
        $("#ddlShiftList").select2({
          placeholder: "Select Shift",
          allowClear: true, tags: true,
          dropdownParent: "#myModal"
        });
        $("#ddlGroup").select2({
          placeholder: "Select Shift",
          allowClear: true, tags: true,
          dropdownParent: "#myModal"
        });

        $('#chkIsLeave').change(function () {
          $('#Txt_UAStartDate').val(''); $('#Txt_UAEndDate').val('');
        });



      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  UAEndMinDate() {

    let _fromDateMin = new Date($('#Txt_UAStartDate').val());
    let _prevDay = ("0" + (_fromDateMin.getDate())).slice(-2);
    let _prevMonth = ("0" + (_fromDateMin.getMonth()) + 1).slice(-2);
    let _prevToday = _fromDateMin.getFullYear() + "-" + (_prevMonth) + "-" + (_prevDay);
    $('#Txt_UAEndDate').attr('min', _prevToday);

  }
  DepartmentDropdownapi(): void {
    ApiMethod.getMethod(this.modelItem.DepartmentDropdownapi).subscribe(
      result => {

        this.Dropdownapi = result.aDeptList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetUserTypeList(): void {
    ApiMethod.getMethod(this.modelItem.GetUserTypeAPI).subscribe(
      result => {

        this.UsertypeList = result.aUserTypeList;

      }, error => {

        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetroleList(): void {
    ApiMethod.getMethod(this.modelItem.GetRolesAPI + '/' + localStorage.aLoginID).subscribe(
      result => {

        this.roleMasterList = result.aRoleList;

      }, error => {

        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });


  }
  GetActivityList(): void {
    ApiMethod.getMethod(this.modelItem.GetActivityList).subscribe(
      result => {

        this.modelItem.activityList = result.activityList;
      }, error => {

        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  GetPublisherList(): void {
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    }
    ApiMethod.getMethod(this.modelItem.PublisherList).subscribe(
      result => {
        this.modelItem.publisherMasterList = result.aitemList;
      }, error => {

        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetJournalList(): void {
    let publisher = $("#lstPublihsers").val().toString();
    ApiMethod.getMethod(this.modelItem.JournalList + '/' + localStorage.aLoginID + '/' + publisher).subscribe(
      result => {
        this.modelItem.journalMasterList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  emailidOnly(event): boolean {
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(event.currentTarget.value)) {
      event.currentTarget.value = '';
      return false;
    }
    return true;

  }

  GetUserMasterList() {
    $("#LoadingImage").show();

    let npublisherId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.UserMasterListAPI + localStorage.aLoginID + '/' + npublisherId).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.userMasterList = result.aitemList;
        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = 'btn_AddNew';
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'UserModule';
        dataItem.infoPopupID = 'UserID';
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  PopupShow(): void {

    this.showModal = true; // Show-Hide Modal Check
    this.content = "This is add New User Master content!!"; // Dynamic Data   
    this.title = "Add User Details";    // Dynamic Data
    this.popUpButtonText = "Add";

    this.resetForm();
    if (localStorage.aEID != 0) {
      $("#LoadingImagePopup").show();
      this.title = "Update User Details";    // Dynamic Data
      this.popUpButtonText = "Update";
      ApiMethod.getMethod(this.modelItem.UserByIDAPI + localStorage.aEID).subscribe(
        result => {
          let item = result.aitemList; // Data List

          //Department Dropdown

          if (item.DepartmentList != null) {
            let datadept = item.DepartmentList.split(',');

            let selectedValue = new Array();
            try {
              for (var i = 0; i < datadept.length; i++) {
                selectedValue[i] = datadept[i];
              }
            } catch (e) {
              console.log(e);
            }
            $('#ddlDepartmentList').val(selectedValue).change();
          }


          $('#txtFirstName').val(item.FirstName);
          $('#txtLastName').val(item.LastName);
          $('#txtLoginID').val(item.LoginID);

          if (item.RoleIdList != null) {
            //RoleId List Populate
            let data = item.RoleIdList.split(',');
            let selectedValues = new Array();
            try {
              for (var i = 0; i < data.length; i++) {
                selectedValues[i] = data[i];
              }
            } catch (e) {
              console.log(e);
            }
            $('#ddlRole').val(selectedValues).change();
          }

          let pubAccess = result.publisherAccess;
          let selectedValuesPub = new Array();

          if (pubAccess[0].PublisherList != null) {
            let dataPub = pubAccess[0].PublisherList.split(',');
            try {

              for (var j = 0; j < dataPub.length; j++) {
                selectedValuesPub[j] = dataPub[j];
              }
            } catch (e) {
              console.log(e);
            }
            $('#lstPublihsers').val(selectedValuesPub).change();
          }


          let selectedValuesJrl = new Array();
          if (pubAccess[0].JournalList != null) {


            try {
              let dataJrl = pubAccess[0].JournalList.split(',');

              for (var k = 0; k < dataJrl.length; k++) {
                selectedValuesJrl[k] = dataJrl[k];
              }

            } catch (e) {
              console.log(e);
            }

          }

          //Allocated Journal popualte
          this.modelItem.JrlIDListPop = selectedValuesJrl;

          $('#ddlManager1').val(item.FirstLineManager);
          $('#ddlManager2').val(item.SecondLineManager);

          $('#txtEmail').val(item.EmailID);
          $('#txtPhoneNo').val(item.PhoneNo);
          $('#ddlActiveStatus').val(item.ActiveStatus).change();
          $('#ddlShiftList').val(item.Shift).change();
          $('#ddlGroup').val(item.WeekendGroup).change();
          let selectedAllocatedPub = new Array();
          if (item.AllocationPublisher != null) {


            try {
              let dataJrl = item.AllocationPublisher.split(',');

              for (var k = 0; k < dataJrl.length; k++) {
                selectedAllocatedPub[k] = dataJrl[k];
              }
              $('#lstAllocatePublihsers').val(selectedAllocatedPub).change();
            } catch (e) {
              console.log(e);
            }

          }
          let selectedAllocatedActivity = new Array();
          if (item.AllocatedActivity != null) {


            try {
              let dataJrl = item.AllocatedActivity.split(',');

              for (var k = 0; k < dataJrl.length; k++) {
                selectedAllocatedActivity[k] = dataJrl[k];
              }
              $('#lstAllocatedActivity').val(selectedAllocatedActivity).change();
            } catch (e) {
              console.log(e);
            }

          }
          $('#txtArticleCount').val(item.ArticleCount);
          $('#txtMaxPages').val(item.MaxPages);
          if (item.AutoAssign != null) {
            $('#chkAutoAssign').prop("checked", (item.AutoAssign));
          }
          else {
            $('#chkAutoAssign').prop("checked", false);
          }

          if (item.IsLeave != null) {
            $('#chkIsLeave').prop("checked", (item.IsLeave));
          }
          else {
            $('#chkIsLeave').prop("checked", false);
          }

          $('#Txt_UAStartDate').val(GlobalConstants.SetValue_FormatDate(item.UnAvailablityStartDate));
          $('#Txt_UAEndDate').val(GlobalConstants.SetValue_FormatDate(item.UnAvailablityEndDate));

          $("#LoadingImagePopup").hide();

          $('a[href="#divGeneral"]').trigger('click');
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Warning !", error.message, "warning");
        });
    }

    $("input.IsNumeric").keydown(function (e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 || (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });
  }
  //Bootstrap Modal Close event
  hide() {
    this.showModal = false;
  }

  onSubmit() {

    let publisherList = $("#lstPublihsers").val().toString();
    let journalList = $("#lstJournals").val().toString();

    if (this.userMasterTabHide == true) {
      publisherList = localStorage.aPubID;
    }

    if ($('#txtFirstName').val().trim() == '' && $('#txtLastName').val().trim() == '') {
      //'Please enter first name or last name ! '
      ngswal("Warning!", 'An invalid entry is present or some required fields are missing. Please check !', "warning");
    }
    else if ($('#txtLoginID').val().trim() == '') {
      ngswal("Warning!", 'Please enter a valid username !', "warning");
    }
    else if ($('#txtEmail').val().trim() == '') {
      ngswal("Warning!", 'Please enter a valid email id !', "warning");
    }
    else if ($('#ddlRole').val() == '' || $('#ddlRole').val() == null) {
      ngswal("Warning!", 'Please select a role for the user !', "warning");
    }
    else if (publisherList == '' || publisherList == null) {
      ngswal("Warning!", 'Please select a publisher for the user !', "warning");
    }
    else if ($('#chkIsLeave').prop("checked") == true && ($('#Txt_UAStartDate').val() == '' || $('#Txt_UAEndDate').val() == '')) {
      ngswal("Warning!", 'Please Select Un Available Start and End Date for the user !', "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      let loginName = $('#txtFirstName').val().trim();
      if ($('#txtLastName').val().trim() != '') {
        loginName = $('#txtFirstName').val().trim() + ' ' + $('#txtLastName').val().trim();
      }

      ApiMethod.getMethod(this.modelItem.CheckUserNameIsExistAPI
        + '/' + $('#txtLoginID').val().trim() + '/' + localStorage.aEID.toString().trim()).subscribe(result => {
          if (!result) {
            let roleId = $('#ddlRole').val().toString().split(",")[0];
            var dataItem = {
              UserID: localStorage.aEID,
              LoginID: $('#txtLoginID').val().trim(),
              LoginName: loginName,
              FirstName: $('#txtFirstName').val().trim(),
              LastName: $('#txtLastName').val().trim(),
              RoleID: roleId,
              RoleIdList: $('#ddlRole').val().toString(),
              PublisherList: publisherList,
              JournalList: journalList,
              DepartmentList: $('#ddlDepartmentList').val().toString(),
              EmailID: $('#txtEmail').val().trim(),
              PhoneNo: $('#txtPhoneNo').val().trim(),
              ActiveStatus: $('#ddlActiveStatus').val(),
              FirstLineManager: $('#ddlManager1').val(),
              SecondLineManager: $('#ddlManager2').val(),
              DefaultPage: $('base')[0].href,
              UpdatedBy: localStorage.aLoginID,
              Shift: $('#ddlShiftList').val(),
              WeekendGroup: $('#ddlGroup').val(),
              AllocationPublisher: $('#lstAllocatePublihsers').val().toString(),
              ArticleCount: $('#txtArticleCount').val().trim() == "" ? 0 : $('#txtArticleCount').val(),
              MaxPages: $('#txtMaxPages').val().trim() == "" ? 0 : $('#txtMaxPages').val(),
              AutoAssign: $('#chkAutoAssign').prop("checked"),
              AllocatedActivity: $('#lstAllocatedActivity').val().toString(),
              IsLeave: $('#chkIsLeave').prop("checked"),
              UnAvailablityStartDate: $('#Txt_UAStartDate').val(),
              UnAvailablityEndDate: $('#Txt_UAEndDate').val()
            };
            ApiMethod.postMethod(this.modelItem.UpdateAPI, dataItem).subscribe(
              result => {
                $("#LoadingImagePopup").hide();
                if (result.Message != null) {
                  ngswal("Update Status", result.Message, "warning");
                }
                else {
                  ngswal("Update Status", result, "info");
                  this.GetUserMasterList();
                  this.hide();
                }
              },
              error => {
                $("#LoadingImagePopup").hide();
                try {
                  ngswal("Warning !", error.error.Message, "warning");
                } catch (e) {
                  ngswal("Warning !", error.Message, "warning");
                }
              }
            );
          }
          else {
            ngswal("Warning", "User Name already available", "warning");
            $("#LoadingImagePopup").hide();
          }
        });

    }
  }

  resetForm() {
    let form: NgForm = $('form');
    form[0].reset();
    $('form input').val('');
    $('#ddlRole').val([]).trigger('change');
    $("#lstPublihsers").val([]).trigger('change');
    $("#lstJournals").val([]).trigger('change');
    $('#ddlDepartmentList').val(0).change();
    $('#ddlShiftList').val(-1).change();
    $('#ddlGroup').val(-1).change();
    $('#lstAllocatePublihsers').val([]).change();
    $('#txtArticleCount').val("");
    $('#txtMaxPages').val("");
    $('#chkAutoAssign').prop("checked", false);
    $('#lstAllocatedActivity').val([]).change();
    $('#chkIsLeave').prop("checked", false);
    $('#Txt_UAStartDate').val(""); $('#Txt_UAEndDate').val("");
  }

  public autoAssign(): void {

    if (localStorage.rowIdVal != "") {

      let colName = localStorage.colName;

      ngswal({

        title: "Update Confirmation !",

        text: "Do you want to update the " + colName + " value ?",

        type: "info",

        showCancelButton: true,

        confirmButtonColor: "#DD6B55",

        confirmButtonText: "Yes, Update!",

        cancelButtonText: "No, Cancel!",

        closeOnConfirm: false,

        closeOnCancel: false

      },

        function (isConfirm) {

          if (isConfirm) {

            $("#LoadingImage").show();

            $('#btnAutoAssign').trigger("click");

          } else {

            $('input[data-idavalue="' + localStorage.rowIdVal + '"][data-colname="' + localStorage.colName + '"]').

              prop('checked', (localStorage.dropId == '0' ? true : false));

            ngswal("Cancelled !", "You clicked cancel! :)", "warning");

          }

        });

    }

  }

  autoAssignConfirm() {
    $("#LoadingImage").show();
    var aItemL = {

      UserID: localStorage.rowIdVal,

      AutoAssign: localStorage.dropId == '0' ? false : true

    }

    ApiMethod.postMethod(this.modelItem.autoAssignApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        ngswal("info !", result, "info");
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");

      });

  }

  Delete() {
    ngswal({
      title: "Are you sure to delete User?",
      text: "User will be deleted permenently",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  DeleteConfirm() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var data = {
      UserID: localStorage.aEID,
      UpdatedBy: localStorage.aLoginID
    };
    ApiMethod.postMethod('api/deleteuserinfo', data).subscribe(
      result => {
        if (result.status == false) {
          ngswal("Failed !", result.message, "warning");
        }
        else {
          ngswal("Success !", result.message, "info");
          this.GetUserMasterList();
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }


}
